module.exports = __webpack_public_path__ + "static/img/images4.7b48056.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/images/images4.jpg
// module id = 1wje
// module chunks = 37